import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchBalanceOnHandTransactionsHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandTransactionHistory',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      transactionId: payload.params.transactionId,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchBalanceOnHandTransactionsHistory;
